module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Citazioni famose")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("\"L")]), _vm._v("a peggiore delle esperienze")]), _vm._v(" può essere trasformata, in effetti a volte si trasforma nella migliore. Ne sono la prova evidente Madam Krystal, Madam Sugar, Madam Yang e le decine di altre domme cinesi assolutamente adorabili con cui ho avuto il grande privilegio di 'stare' se mi è permesso di usare questo termine\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Non c'è nessun livello della degradazione che non possa essere esplorata, nessuna umiliazione troppo estrema, nessuna punizione troppo severa per un servo. Soprattutto con una 'pila' illustrissima, se posso usare questo termine, di belle, dominanti, esigenti e autoritarie donne cinesi, dove Madam Krystal è la cima.\"")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "font-weight": "bold"
    }
  }, [_vm._v("Mike Watson, ottobre 2017, “Krystal – the Teaching Assistant – the Second Sequel”")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene with-quote",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("“")]), _vm._v("Servo! Spegni la luce")]), _vm._v(" e massaggiami la parte bassa della schiena! Voglio dormire, zitto ora!\"")]), _vm._v(" "), _c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "poetry",
    staticStyle: {
      "font-style": "italic",
      "font-weight": "bold"
    }
  }, [_vm._v("Madam Suvi, ottobre 2017, \"Mai, my lovely maid\"")])]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene with-quote"
  }, [_vm._v("\"È")]), _vm._v(" una bellissima ragazza")]), _vm._v(" di 23 anni della provincia del Guangxi, nel sud della Cina, e sa parlare un po' di inglese (non molto). Lavora come HR generalist in una delle fabbriche qui vicino, ma ovviamente, come con la maggior parte delle donne cinesi che ho incontrato, ha solo un obiettivo in mente, e le mie gambe si sono letteralmente sciolte guardando quella foto, quei suoi bei lunghi capelli lisci e quei grandi "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("maliziosi")]), _vm._v(" occhi neri a mandorla... e quello sguardo, Dio, quello sguardo fisso e severo su di me dalla parola 'via!'")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mio "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Dio")]), _vm._v(", mi ricorda una "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("giovane imperatrice Cody")]), _vm._v(", e anche se non sono minimamente preoccupato per l'età dell'imperatrice, suppongo sia un altro il motivo per cui lo sto dicendo.\"")]), _vm._v(" "), _c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "poetry",
    staticStyle: {
      "font-style": "italic",
      "font-weight": "bold"
    }
  }, [_vm._v("Mike Watson, ottobre 2017 “Empress Cody – Volume #4”")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("In fin dei conti, il vero femdom non può che essere misurato da UNA sola cosa e basta - quello \"sguardo\" nei suoi occhi. Quello sguardo malizioso. Quella risatina furba - - il tacito riconoscimento di una sottomessa in SUA presenza, l'UNICO obiettivo - - ovvero usare e manipolare per il SUO piacere... così come DOVREBBE sempre essere.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "font-style": "italic",
      "font-weight": "bold"
    }
  }, [_vm._v("Mike Watson, aprile 2018, “A complete guide to the mainland Chinese female for the truly submissive male”.")])]), _c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "justify"
    }
  }), _c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "poetry",
    staticStyle: {
      "font-size": "x-large",
      "font-weight": "bold"
    }
  }, [_vm._v("INTRODUZIONE")])]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene"
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")]), _vm._v("nnanzitutto, mi tocca")]), _vm._v(" presentarmi per chi sono. Questa introduzione è disponibile anche sul mio sito web "), _c('a', {
    attrs: {
      "href": "http://www.spicyanderoticfetish.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.spicyanderoticfetish.com.")])]), _vm._v(" "), _c('p', [_vm._v("In effetti, potresti voler consultare il sito prima di continuare a leggere questo manuale, perché ti aiuterà a capire \"chi sono\" dalla prospettiva discussa e inquadrerà in un ulteriore contesto più pertinente tutto ciò che dirò.")]), _vm._v(" "), _c('p', [_vm._v("Sono il tipico ragazzo di tutti i giorni che si è interessato alla Dominazione Femminile da quando ne ho memoria. Scrivo romanzi fetish da un po' di tempo e ho avuto la fortuna di incontrare un sacco di donne che sono state più che disposte a godere della mia \"servitù\" nella \"vita reale\".")]), _vm._v(" "), _c('p', [_vm._v("E quando dico \"vita reale\", intendo la vita reale.")]), _vm._v(" "), _c('p', [_vm._v("Non intendo una \"sessione\" quando mi riferisco a massaggiare i piedi (o \"premendo i piedi\" come ad alcune signore cinesi piace definirlo, hehe), bensì al servirla dopo una dura giornata e di solito dopo una conversazione considerata \"vaniglia\". ")]), _vm._v(" "), _c('p', [_vm._v("O la testa, la schiena o le spalle, se è per questo.")]), _vm._v(" "), _c('p', [_vm._v("Ho un enorme feticismo per il piede e questo si aggiunge a TUTTI gli aspetti della mia vita quotidiana (così come altri \"interessi\" legati alla dominazione femminile).")]), _vm._v(" "), _c('p', [_vm._v("Non approfondirò \"altri\" dettagli personali ora, quanto invece per i dettagli che sono rilevanti per ciò che viene discusso, che in questo caso è il fetish.")]), _vm._v(" "), _c('p', [_vm._v("In particolare, parliamo della sindrome di dominazione \"della donna sull’uomo\". Ancora più specificamente, anche se la maggior parte di quello che sto dicendo in questo manuale è applicabile alle donne di tutto il mondo in generale, ma ad UNA categoria in particolare - - alle donne della Cina continentale.")]), _vm._v(" "), _c('p', [_vm._v("NON donne cinesi di Hong Kong. Non \"donne cinesi d'oltremare\". No, ne ho scritto nella MAGGIOR PARTE dei miei libri finora - - ma questo è interamente dedicato alle donne della Cina continentale, che come ho già detto molte volte, sono probabilmente la forza femminile che in natura \"tendono\" più alla dominazione su tutto il pianeta.")]), _vm._v(" "), _c('p', [_vm._v("(I link ai miei libri sono disponibili sul mio sito web"), _c('a', {
    attrs: {
      "href": "http://www.spicyanderoticfetish.com/",
      "target": "_blank"
    }
  }, [_vm._v(" www.spicyanderoticfetish.com.")]), _vm._v(" Ho lavorato con Femdom Cave publications per tutti i miei libri fino ad oggi - - sono ragazzi in gamba, il mio sito rimanda direttamente ai prodotti sul loro sito dove è possibile acquistare i libri direttamente).")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }, [_vm._v("Ancora PIÙ importante, questo manuale tratta COME esattamente “trasformare” la vostra donna (o una donna cinese) in un ruolo più, MOLTO più dominante.")]), _vm._v(" "), _c('p', [_vm._v("Innanzitutto, voglio ripeterti che non si tratta di una \"scena\", o una \"sessione di dominazione professionale\". Queste due cose sono ampiamente disponibili su Internet e non richiedono assolutamente nessuna guida pratica.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Quello con cui la maggior parte degli uomini ha difficoltà e su cui poi fallisce miseramente, è come integrare la dominazione femminile nelle loro relazioni \"vanilla\" con le donne.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Ciò che la maggior parte degli uomini (interessati a questo) \"vogliono\" (o \"pensano di volere\") non è il dominio 24 ore su 24, 7 giorni su 7, ma \"molto di più di quello che ottengono attualmente\".")]), _c('p', [_vm._v("Perché? Beh, perché... ma, aspetta, tratteremo dei \"perché\" nella parte dei suggerimenti. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Questo manuale è un tentativo di affrontare la sindrome e CORREGGERLA. ")]), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Perché sono \"qualificato\" per dirti come risolvere il problema?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Perché proprio io sono la persona giusta per scrivere questo manuale?")]), _vm._v(" "), _c('p', [_vm._v("Beh, perché ci sono passato anch' io. TUTTO ciò che ho scritto in questo manuale è tratto esperienze di vita reale che mi sono successe nei circa 15 anni che ho vissuto in Cina continentale.")]), _vm._v(" "), _c('p', [_vm._v("Ora penso che valga la pena ricordare che non credo nelle relazioni \"24/7\" di qualsiasi tipo, che siano o meno vanilla.")]), _vm._v(" "), _c('p', [_vm._v("Metti un marito e moglie \"insieme\" sotto lo stesso tetto senza alcun contatto con il sesso opposto per un paio di mesi, vedrai poi cosa succederà.")]), _vm._v(" "), _c('p', [_vm._v("Non sarà un bello spettacolo.")]), _vm._v(" "), _c('p', [_vm._v("Allo stesso modo, la dominazione 24/7 di qualsiasi natura, tipo o forma funziona soltanto nella terra della fantasia. La vita reale NON è una fantasia.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Detto questo, si POSSONO aumentare notevolmente gli atteggiamenti \"dominanti\" della vostra partner anche in una relazione vanilla. Solo... non aspettarti una dinamica \"24/7\", bensì qualcosa di \"abbastanza simile” solo se fatta nel modo giusto.")]), _vm._v(" "), _c('p', [_vm._v("\"La diversità è il sale della vita\" e questo vale anche per le relazioni e il feticismo.")]), _vm._v(" "), _c('p', [_vm._v("L'unica cosa che voglio dire prima di iniziare è un enorme GRAZIE a tutte le donne cinesi con cui ho avuto a che fare in passato. Indirettamente o direttamente, consapevolmente o inconsapevolmente hanno TUTTE contribuito a stuzzicare il mio interesse per la dominazione femminile e credetemi, ne sono stato MOLTO interessato da quando ne ho memoria.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "page-break-before": "always"
    }
  }, [_vm._v("Per saperne di più, cerca alla fine di questo manuale.")]), _vm._v(" "), _c('p', [_vm._v("Un enorme ringraziamento va alle donne in generale, in realtà. Le mie migliori esperienze sono state con le donne cinesi, ma di base ho sempre avuto buoni \"rapporti\" di qualsiasi tipo con le donne in generale, indipendentemente da razza, colore o nazionalità.")]), _vm._v(" "), _c('p', [_vm._v("Sospetto tutto ciò non si traduca che in un genuino rispetto per le donne (che è in realtà uno dei prossimi suggerimenti) al contrario della \"lussuria\" o del \"rispetto per rispetto\".")]), _vm._v(" "), _c('p', [_vm._v("Si riduce anche in parte a riconoscere, comprendere e apprezzare il FATTO che fondamentalmente uomini e donne sono diversi sotto molti aspetti e sarà sempre così, un'altro dei prossimi suggerimenti.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Ancora grazie, donne. Vi meritate tutti i riconoscimenti possibili!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Ultimo, ma certamente non meno importante, è il principio \"SSC\" da tener bene a mente mentre si legge il manuale, così importante che ne parlerò prima di iniziare.")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Sicurezza")]), _vm._v(": - NON mettere in pericolo il tuo o la tua partner in alcun modo o maniera. Se hai dei dubbi, chiedi a professionisti QUALIFICATI.")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Senno")]), _vm._v(": - Auto - esplicativo. Si può avere l'idea folle, per esempio, di far correre il o la partner per strada senza vestiti cantando ninne nanne, ma ricorda che questo potrebbe non funzionare benissimo nel \"mondo reale\". Come dicono i ragazzi di FDC, \"Tieni un piede nel mondo reale\".")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Consenso")]), _vm._v(": - Questo è così importante che merita un libro a sé. In breve, non costringere nessuno a nulla né direttamente né indirettamente (quest' ultimo in particolare).")]), _vm._v(" "), _c('p', [_vm._v("Da notare che \"parlare\" o \"metterla a suo agio\" è "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("diverso")]), _vm._v(" da \"forzarla\" o \"farglielo andare bene a forza\".")]), _vm._v(" "), _c('p', [_vm._v("Sii "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ragionevole")]), _vm._v(". Sii "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("adulto")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("A questi tre e a quanto detto sopra, aggiungerei un quarto – LEGALE. Assicurati che tutte le attività discusse e a cui partecipi siano legali nella giurisdizione di residenza.")]), _vm._v(" "), _c('p', [_vm._v("Lo STESSO vale per coloro con cui hai delle relazioni. ")]), _vm._v(" "), _c('p', [_vm._v("Senza ulteriori indugi dunque, iniziamo.")]), _c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "justify"
    }
  }), _c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "poetry",
    staticStyle: {
      "font-size": "x-large",
      "font-weight": "bold"
    }
  }, [_vm._v("Cosa puoi aspettarti da questo manuale?")])]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-c"
  }, [_vm._v("C")]), _vm._v("ome dice il titolo")]), _vm._v(", 20 "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "text-decoration": "underline"
    }
  }, [_vm._v("consigli PRECISI, POTENTI e REALI")]), _vm._v(" che TRASFORMERANNO la tua donna di tutti i giorni nella Domme che era naturalmente destinata ad essere. Tuttavia, i suggerimenti funzionano solo se li leggi, comprendi e poi "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("applichi nel modo in cui ti dico")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Ricorda anche che, alla fine della giornata, la scelta è sempre e completamente di lei (in questo tipo di relazione).")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Quell' ultima parte è la CHIAVE (gioco di parole VOLUTO per coloro che sono attualmente in una sessione di castità forzata o ancora in cerca).")]), _vm._v(" "), _c('p', [_vm._v("Falle il bucato, ma non aspettarti niente in cambio oltre quello sguardo felice nei suoi occhi. La dominazione femminile NON è una scusa per l'uomo solo per ricevere piacere, e paradossalmente se si seguono i miei consigli, si può finire per ottenere PIÙ \"piacere\" di quanto \"contrattato\" all'inizio (anche se può non essere nella forma desiderata).")]), _vm._v(" "), _c('p', [_vm._v("D'altronde, potresti anche non ricevere nulla. Potrebbe anche addormentarsi dopo che le hai leccato l'ano per un po'. Accettalo. Farà a modo suo.")]), _vm._v(" "), _c('p', [_vm._v("Potrebbe piacerti massaggiarle i piedi, ma potrebbe piacerle di più un massaggio alla testa.")]), _vm._v(" "), _c('p', [_vm._v("E così via.")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-size": "x-large",
      "font-weight": "bold"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-c"
  }, [_vm._v("C")]), _vm._v("osa NON aspettarsi")]), _vm._v(".")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('li', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Non è una \"storiella\" o un romanzo fetish, se è per questo. Certo, stiamo parlando di fetish e quindi parleremo di tutti i kink correlati, ecc... ma l'inclinazione principale sarà quella \"mentale\" e ciò che davvero \"funziona\" per gli scenari \"F on m\".")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("("), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Se sei però alla ricerca di romanzi, allora il mio sito web sarebbe un buon punto di partenza.")]), _vm._v(")")])]), _c('ul', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('li', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Né questa è una guida indiretta per \"dominare dal basso\", questo è qualcosa che affronteremo in seguito.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Per apprezzare appieno ciò che scrivo, devi essere \"veramente interessato\" nella dominazione femminile e non solo a \"venire\". C'è una differenza enorme tra i due, ragazzi.")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("A seguito di quanto sopra, non ci saranno suggerimenti intesi a \"servire l'interesse sessuale maschile\", anche se per quelli di voi che sono VERAMENTE e genuinamente interessati alla dominazione femminile, probabilmente avrete un'erezione terribile per tutto il tempo di lettura.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }, [_vm._v("Compreso questo, procediamo. Se quanto ho detto prima ti sembra assolutamente e completamente sgradevole, allora questo manuale NON fa per te.")]), _vm._v(" "), _c('p', [_vm._v("Ancora una volta, ricorda che i suggerimenti sottostanti si applicheranno alle relazioni \"femdom\" in generale, ma ho scoperto che (per qualsiasi motivo) valgono di PIÙ per le donne della Cina continentale.")]), _vm._v(" "), _c('p', [_vm._v("Cominciamo!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26644936","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c006.vue
// module id = 75
// module chunks = 0